const toolbarMenuGroupStartClass = "mdln-kendo-toolbar-menu-group-start";

export type KendoHtmlAttributes = Readonly<Record<string, string>>;

/**
 * Marks a real Kendo ToolBar menu item as the start of a visual group.
 *
 * ToolBar DropDownButtons use ButtonMenu, which does not support separator
 * items. A separator definition would therefore become a blank, focusable row.
 */
export function toolbarMenuGroupStart(attributes: KendoHtmlAttributes = {}):
	{ readonly attributes: KendoHtmlAttributes } {
	const className = [attributes.class, toolbarMenuGroupStartClass].filter(Boolean).join(" ");
	// Kendo consumes and mutates item attributes while rendering, so each call
	// must return a fresh object rather than a shared definition.
	return { attributes: { ...attributes, class: className } };
}
